import axios from "axios";
import  { infraConfig } from "config/infraConfig";
import { getAxiosConfig } from "system/axiosConfig";
import store from "system/store";
import { ERRORMESSAGES_ADD } from "system/actions";
import { openFileWindow } from "system/util.js";


export const POLICYDOCS_GET_DOCUMENTS = "POLICYDOCS_GET_DOCUMENTS";
export const POLICYDOCS_GET_DOCUMENTS_SUCCESS = "POLICYDOCS_GET_DOCUMENTS_SUCCESS";
export const POLICYDOCS_GET_DOCUMENTS_FAILED = "POLICYDOCS_GET_DOCUMENTS_FAILED";

export const POLICYDOCS_GET_FILE = "POLICYDOCS_GET_FILE";
export const POLICYDOCS_GET_FILE_SUCCESS = "POLICYDOCS_GET_FILE_SUCCESS";
export const POLICYDOCS_GET_FILE_FAILED = "POLICYDOCS_GET_FILE_FAILED";


export function fetchDocuments() {
    
    return (dispatch) => {
        dispatch({type: POLICYDOCS_GET_DOCUMENTS});

        const user = store.getState().oidc.user;
        axios.get(infraConfig.apiEndpoint.concat('/api/policydocs/documents'), getAxiosConfig(user))
        .then((dataResult) => dispatch({type: POLICYDOCS_GET_DOCUMENTS_SUCCESS, payload: dataResult}))
        .catch((error) => { dispatch({type: POLICYDOCS_GET_DOCUMENTS_FAILED}); dispatch({type: ERRORMESSAGES_ADD, payload: { type: 'network', message: 'Hämta dokument misslyckades', severity: 'warning'}});});

    }
    
};

export function downloadDocumentFile(filename) {
    return (dispatch) => {
        dispatch({type: POLICYDOCS_GET_FILE});

        const user = store.getState().oidc.user;
        axios.get(infraConfig.apiEndpoint.concat('/api/policydocs/downloadfile?filename=').concat(filename), getAxiosConfig(user))
        .then((dataResult) => {
            dispatch({type: POLICYDOCS_GET_FILE, payload: dataResult});
    
           // console.log('got file', dataResult);
            openFileWindow(dataResult.data.result);

        }
        
        )
        .catch((error) => { dispatch({type: POLICYDOCS_GET_FILE_FAILED}); dispatch({type: ERRORMESSAGES_ADD, payload: { type: 'network', message: 'Hämta dokumentfil misslyckades', severity: 'warning'}});});

    }

}


